import React from 'react';
import { Col } from 'react-bootstrap';
import { AnswerFieldProps } from './QuestionField';
import { Checkbox } from 'components/controls/Checkbox';

export const QuestionRadio = (props: AnswerFieldProps) => {
	return (
		<React.Fragment>
			{
				props.answerValue.values.map((x, index) => {
					return (
						<Col key={`${x.value}`} xs='auto' onClick={() => props.valueChanged?.(x.value)} className='question-radio'>
							<Checkbox checked={props.currentValue === x.value}
								disabled={props.disabled}
								onChange={() => props.valueChanged?.(x.value)}
								onClick={() => props.valueChanged?.(x.value)}
								value={x.value}
								id={`${props.idPrefix}_checkbox${index}`}
							/>
							<label className='question-radio-label' htmlFor={`${props.idPrefix}_checkbox${index}`}>{x.text}</label>

						</Col>
					)
				})
			}
		</React.Fragment>
	);
}